import { Box, Skeleton } from '@mantine/core';
import { useIntersection } from '@mantine/hooks';
import { ReactNode, useEffect, useState } from 'react';

interface LazyTimelineItemProps {
  children: ReactNode;
  fallbackHeight?: number;
  rootMargin?: string;
  forceRender: boolean;
}

/**
 * Lazy loading wrapper for timeline items that only renders content when it's about to enter the viewport
 */
export function LazyTimelineItem({
  children,
  fallbackHeight = 120,
  rootMargin = '200px',
  forceRender = false,
}: LazyTimelineItemProps) {
  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  const { ref, entry } = useIntersection({
    threshold: 0,
    rootMargin,
  });

  // Once the item has been visible, keep it rendered to avoid flickering
  useEffect(() => {
    if ((entry?.isIntersecting || forceRender) && !hasBeenVisible) {
      setHasBeenVisible(true);
    }
  }, [entry, hasBeenVisible, forceRender]);

  return (
    <Box ref={ref}>{hasBeenVisible || forceRender ? children : <Skeleton height={fallbackHeight} radius="md" />}</Box>
  );
}
